/* eslint-disable @typescript-eslint/naming-convention */
import * as L from 'leaflet';

export class SensorMarker extends L.Marker {
  sensor_id: string;
  sensor_type: string;
  device_id: string;
  device_name: string;
  device_eui: string;
  address: string;
  latlang: L.LatLngExpression;
  buildingID: string;
  locationContext: string;
  alarmRuleEnabled: boolean;
  currentQuality?: any;
  ruleJSON?: any;
  reading?: any;

  constructor(
    sensor_id: string,
    sensor_type: string,
    device_id: string,
    device_name: string,
    device_eui: string,
    address: string,
    latlang: L.LatLngExpression,
    buildingID: string,
    locationContext: string,
    alarmRuleEnabled: boolean,
    currentQuality?: any,
    ruleJSON?: any,
    reading?: any,
    options?: L.MarkerOptions,
  ) {
    super(latlang, options);
    this.sensor_id = sensor_id;
    this.sensor_type = sensor_type;
    this.device_id = device_id;
    this.device_name = device_name;
    this.device_eui = device_eui;
    this.address = address;
    this.latlang = latlang;
    this.buildingID = buildingID;
    this.locationContext = locationContext;
    this.alarmRuleEnabled = alarmRuleEnabled;
    this.currentQuality = currentQuality;
    this.ruleJSON = ruleJSON;
    this.reading = reading;
  }
}
